module.exports = __webpack_public_path__ + "assets/img/kv-1e1d195e.jpg";